module.exports = __webpack_public_path__ + "img/点变家-05.f708aba9.png";